<template>
  <div class="m-r-4 m-l-4">
    <Popover
      class="warning-notice p-r-6"
      placement="top"
      :visible="showWarning"
      :overlayStyle="{ width: '500px' }"
      trigger="click"
      :on-visible-change="triggerDisplay"
    >
      <template #title>
        <div
          class="report-tips p-b-4 p-t-4 flex flex-col-middle flex-row-between"
        >
          <span>* 预警通知（仅展示最近3天的数据）</span>
          <Button
            v-if="store.getNotReadNumber"
            type="link"
            size="small"
            @click="setHasRead()"
            >全部已读</Button
          >
        </div>
      </template>
      <template #content>
        <div v-if="noticeList.length" class="content">
          <div
            v-for="item in noticeList"
            class="p-b-6 p-t-6 cursor"
            :class="{ readClass: item.hasRead }"
            @click="setHasRead(item)"
          >
            <div>{{ item.gmtCreate }}</div>
            <div>{{ item.content }}</div>
          </div>
        </div>
        <div v-else>
          <Empty description="暂无通知" :image="Empty.PRESENTED_IMAGE_SIMPLE" />
        </div>
      </template>
      <div>
        <Badge :count="store.getNotReadNumber" :number-style="countStyle">
          <i
            style="font-size: 22px"
            class="iconfont icon-lingdang text-secondary"
          ></i>
        </Badge>
      </div>
    </Popover>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { Popover, Badge, Button, Empty } from 'ant-design-vue';
import { useServiceStore } from '/@/store/modules/service';
import { getWarningApi, readWarningApi } from '/@/api/common';
const store = useServiceStore();
const showWarning = ref(false);
const noticeList = ref<any>([]);

const countStyle = {
  minWidth: '10px',
  height: '16px',
  lineHeight: '16px',
  padding: '0 4px',
};
onMounted(() => {
  fetchNoticeList();
});

const fetchNoticeList = async () => {
  const {
    content: { notReadNum, list },
  } = await getWarningApi();
  store.setNotReadNumber(notReadNum);
  noticeList.value = list;
};
//
const readWarning = async (pkId: any): Promise<any> => {
  const pkIds = pkId ? [pkId] : noticeList.value?.map((item) => item.pkId);
  await readWarningApi({
    pkIds,
  });
};
// 点击消息已读
const setHasRead = (item?: any) => {
  if (store.getNotReadNumber <= 0 || item?.hasRead == 1) return;
  if (!item) {
    noticeList.value = noticeList.value?.map((item: any) => ({
      ...item,
      hasRead: 1,
    }));
    store.setNotReadNumber(0);
    readWarning('');
  } else {
    noticeList.value = noticeList.value?.map((v: any) => {
      return item.pkId == v.pkId ? { ...v, hasRead: 1 } : { ...v };
    });
    store.setNotReadNumber(store.getNotReadNumber - 1);
    readWarning(item.pkId);
  }
};
const triggerDisplay = () => {
  showWarning.value = !showWarning.value;
  if (showWarning.value) {
    fetchNoticeList();
  }
};
</script>

<style lang="less" scoped>
.readClass {
  color: #999;
}
.content {
  max-height: 300px;
  overflow: auto;
}
.cursor {
  cursor: pointer;
}
</style>
